import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const imgWrap = css`
  padding: var(--space-1000) var(--space-500) 0;

  ${breakpoints.only.smMobile} {
    padding: var(--space-700) var(--space-200) 0;
  }
`;

export const imgStyle = css`
  display: block;
  width: 400px;
  height: 135px;
  margin: 0 auto;

  ${breakpoints.only.mobile} {
    width: 340px;
    height: 114px;
  }

  ${breakpoints.only.smMobile} {
    width: 288px;
    height: 97px;
  }
`;

export const backButtonStyle = css`
  margin: var(--space-400) var(--space-500) var(--space-500);

  ${breakpoints.only.smMobile} {
    margin: 0 var(--space-200) var(--space-200);
  }
`;

export const modalHeaderStyle = css`
  width: 100%;
  padding: var(--space-500) var(--space-500) var(--space-200) var(--space-500);

  ${breakpoints.only.smMobile} {
    padding: var(--space-200);
  }
`;

export const modalContentWrapStyle = css`
  ${breakpoints.only.smMobile} {
    margin: auto 0;
  }
`;

export const modalContentStyle = css`
  overflow-y: hidden !important;
`;
